/** The input bar: placeholder, action buttons, chat context, attachments. */
export default {
  preparingImage: " · Preparing image…",
  browserImageSyncHint:
    "To use a local browser image with a desktop agent, choose Sync image.",
  askAnything: "Ask anything...",
  askAgent: "Ask {name}...",
  askTeam: "Ask the team...",
  message: "Message",
  orchestrating: {
    one: "Denker orchestrates · {count} agent will be dispatched",
    other: "Denker orchestrates · {count} agents will be dispatched",
  },
  resume: "Resume",
  resuming: "Resuming…",
  stop: "Stop",
  stopping: "Stopping…",
  stopGenerating: "Stop generating",
  dictate: "Dictate",
  stopDictation: "Stop dictation",
  queued: "{count} queued",
  fixCompanion: "Fix companion",
  companionDisconnected: "Companion disconnected — click to fix",
  newChat: "New chat",
  send: "Send",
  attachFiles: "Attach files",
  chatContext: "Chat context",
  openChatContext: "{title}. Open chat context",
  newChatNoContext: "New chat, 0% context used",
  newChatSelected: "New chat selected",
  contextUnavailableInChat: "Context usage unavailable in current chat",
  currentChatContext: "Current chat context",
  contextUnavailable: "Context usage unavailable",
  continueCurrentChat: "Continue current chat",
  question: "Question",
  questionOf: "Question {position} of {total}",
  answerQuestion: "Answer the question…",
  addInstructions: "Add instructions…",
  chatCannotReceive: "This chat cannot receive messages.",
  loadingTaskControls: "Loading task controls…",
  openInAppToContinue: "Open in {app} to continue",
  doneContinueHereOrInApp: "Done. Continue here or in {app}.",
  yourCodingApp: "your coding app",
  waitingForReply: "Waiting for your reply",
  openParentConversation: "Open parent conversation",
  attachedImage: "Attached image",
  screenshot: "Screenshot",
  image: "Image",
  uploading: " · Uploading…",
  uploadingPercent: " · Uploading {percent}%",
  uploadFailed: " · Upload failed",
  attachFileFailed: "Couldn’t attach file",
  attachClipboardFileFailed: "Couldn’t attach clipboard file",
  attachClipboardImageFailed: "Couldn’t attach clipboard image",
  copyImageAgain: "Copy the image and try pasting again.",
  rememberWord: "Remember <b>{word}</b> for voice?",
  remember: "Remember",
  rememberFailed: "Couldn’t remember. Try again.",
  dismiss: "Dismiss",
} as const;
